import { IFormFieldSaveBind } from './form-field-save-bind.model';

export interface IFormSaveBind {
  formId: string;
  dynamicFormFields: IFormFieldSaveBind[];
}

export class FormSaveBind implements IFormSaveBind {
  formId: string;
  dynamicFormFields: IFormFieldSaveBind[];

  constructor();
  constructor(obj: IFormSaveBind);
  constructor(obj?: IFormSaveBind) {
    this.formId = obj?.formId ?? '';
    this.dynamicFormFields = obj?.dynamicFormFields ?? [];
  }
}
